<template>
  <div class="no-results">
    <i class="fas fa-search no-results-icon"></i>
    <p>No instructors found matching your search criteria.</p>
  </div>
</template>

<script>
export default {
  name: 'NoResults'
};
</script>

<style scoped>
.no-results {
  text-align: center;
  padding: 2rem 1rem;
  background: var(--bg-white);
  border-radius: var(--radius-lg);
  margin: 2rem 0;
  box-shadow: var(--shadow-lg);
}

.no-results-icon {
  font-size: 2rem;
  color: var(--text-light);
  margin-bottom: 0.7rem;
}

.no-results p {
  color: var(--text-medium);
  font-size: 1rem;
  margin: 0;
  font-weight: 500;
}
</style> 